<div
  class="wishtime-group-header"
  [ngClass]="{
    'checkout-variant': variant === 'checkout',
    'catalog-variant': variant === 'catalog',
  }"
  *ngIf="wishTimeKey !== 'NO_WISHTIME'"
>
  <div *ngIf="variant === 'checkout'" class="font-weight-bold mt-3">
    <span>
      {{
        wishTimeKey
          | localizedDate
            : 'ddd DD MMM'
            : (userLang$ | async)
            : selectedStore?.timeZone
          | async
      }}
      {{
        isTimeShowDisabled
          ? ''
          : (wishTimeKey
            | formattedTime
              : selectedStore?.settings?.TIME_FORMAT_SELECTION
              : selectedStore?.locale)
      }}
    </span>
    <hr />
  </div>

  <!-- Catalog variant styling -->
  <div
    *ngIf="variant === 'catalog'"
    class="font-weight-bold theme-color-header"
  >
    <span class="font-weight-bold">
      {{
        groupItems[0].wishTime
          | localizedDate
            : 'ddd DD MMM'
            : (userLang$ | async)
            : selectedStore?.timeZone
          | async
      }}
      {{
        isTimeShowDisabled
          ? ''
          : (groupItems[0].wishTime
            | formattedTime
              : selectedStore?.settings?.TIME_FORMAT_SELECTION
              : selectedStore?.locale)
      }}
    </span>
    <hr />
  </div>
</div>
